import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { controlSectionStyles, iconButtonStyles } from '../dashboardStyles';

interface AvailabilityHeaderProps {
  label: string;
  onPrevious: () => void;
  onNext: () => void;
}

export function AvailabilityHeader({ label, onPrevious, onNext }: AvailabilityHeaderProps) {
  return (
    <Box sx={controlSectionStyles}>
      <Typography
        variant="h6"
        sx={{
          height: '3rem',
          fontWeight: 600,
          pt: 1,
        }}
      >
        Availability
      </Typography>

      <Box sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={onPrevious}>
          <KeyboardArrowLeft fontSize="small" />
        </IconButton>

        <Typography
          component="span"
          sx={{
            px: 0.5,
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>

        <IconButton sx={iconButtonStyles} onClick={onNext}>
          <KeyboardArrowRight fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
